import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useLead } from "../../context/LeadContext";
import { scrollToId } from "../../lib/scroll";

const LINKS = [
  { label: "Firmenkunden", href: "#konditionen", testid: "nav-firmenkunden" },
  { label: "KIA Modelle", href: "#modelle", testid: "nav-modelle" },
  { label: "Ansprechpartner", href: "#ansprechpartner", testid: "nav-ansprechpartner" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { requestOfferte } = useLead();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-b border-neutral-200" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-16 sm:h-20">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex flex-col items-start leading-none"
        >
          <span className={`font-display font-bold text-lg tracking-tight transition-colors ${scrolled ? "text-neutral-950" : "text-white"}`}>
            Künzler &amp; Sauber
          </span>
          <span className={`text-[10px] uppercase tracking-[0.3em] mt-1 transition-colors ${scrolled ? "text-neutral-500" : "text-neutral-300"}`}>
            KIA Firmenkunden
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => go(l.href)}
              className={`text-sm font-medium tracking-wide transition-colors hover:opacity-100 ${
                scrolled ? "text-neutral-600 hover:text-neutral-950" : "text-neutral-200 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-offerte"
            onClick={() => requestOfferte()}
            className="group relative overflow-hidden bg-white text-neutral-950 text-sm font-semibold px-6 py-2.5 transition-colors"
            style={scrolled ? { background: "#0a0a0a", color: "#fff" } : {}}
          >
            Firmenofferte
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className={`lg:hidden p-2 ${scrolled ? "text-neutral-950" : "text-white"}`}
          onClick={() => setOpen(!open)}
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-neutral-200 px-5 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={() => go(l.href)}
              className="text-left text-base font-medium text-neutral-800 py-1"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-offerte-mobile"
            onClick={() => { setOpen(false); requestOfferte(); }}
            className="mt-2 bg-neutral-950 text-white text-sm font-semibold px-6 py-3"
          >
            Firmenofferte anfordern
          </button>
        </div>
      )}
    </header>
  );
}
